export const WIND_DIR_MAP = {
  N: 0,
  ENE: 67.5,
  NNE: 22.5,
  NE: 45,
  E: 90,
  ESE: 112.5,
  SE: 135,
  SSE: 157.5,
  S: 180,
  SSW: 202.5,
  SW: 225,
  WSW: 247.5,
  W: 270,
  WNW: 292.5,
  NW: 315,
  NNW: 337.5,
};

export const CARD_DIR_MAP = {
  0: 'N',
  22.5: 'NNE',
  45: 'NE',
  67.5: 'ENE',
  90: 'E',
  112.5: 'ESE',
  135: 'SE',
  157.5: 'SSE',
  180: 'S',
  202.5: 'SSW',
  225: 'SW',
  247.5: 'WSW',
  270: 'W',
  292.5: 'WNW',
  315: 'NW',
  337.5: 'NNW',
};

const sortedKeys = Object.keys(CARD_DIR_MAP)
  .map((key) => parseFloat(key))
  .sort((a, b) => a - b);

export function between(x, min, max) {
  return x >= min && x < max;
}

export function discernDirection(windAngle) {
  const normalizedAngle = windAngle % 360;
  const key = sortedKeys.find((k, i) =>
    between(normalizedAngle, parseFloat(k), sortedKeys[i + 1] || 360)
  );
  return CARD_DIR_MAP[key];
}

export function convertDirection(direction) {
  const directionNumber = parseFloat(direction);
  if (Number.isNaN(Number(directionNumber))) {
    return WIND_DIR_MAP[direction];
  }
  const discernedDirection = discernDirection(directionNumber);
  return discernedDirection;
}
